import React, { useMemo } from 'react';
import { Box } from '@chakra-ui/react';

import { ListLoader } from '@app/screens/pools/components/ListLoader';
import { NoKpNftView } from '@app/screens/positions/components/NoKpNftView';
import s from './SpNftsList.module.scss';
import { MySpNftHeader } from '@app/screens/nft-marketplace/SpNftOffersModal/MySpNftTab/MySpNFTHeader';
import { useKpNftPositions } from '@app/hooks/nft/useKpNftPositions';
import { StaggeredList } from '@app/components/StaggeredList';
import { PairToken } from '@app/types/pool';
import { AnimatePresence } from 'framer-motion';
import { SpNftModalRowItem } from '@app/screens/nft-marketplace/SpNftOffersModal/SpNftModalRow';
import { useMedia } from 'react-use';

export const MyPositionsNftMarketplaceView = () => {
  const isMobile = useMedia('(max-width: 960px)', true);
  const { data: kpNftPositions, isLoading } = useKpNftPositions();

  const mergedData = useMemo(() => {
    if (!kpNftPositions) {
      return [];
    }

    return [
      ...kpNftPositions.map(pos => {
        return {
          data: pos,
          isStakedToNitro: false,
          nitroPoolId: undefined,
          poolAddress: pos.nftPool.id,
          lpToken: pos.nftPool.lpToken
        };
      })
    ];
  }, [kpNftPositions]);

  function renderList() {
    if (isLoading) {
      return <ListLoader />;
    }

    if (!mergedData || mergedData.length === 0) {
      return <NoKpNftView />;
    }

    return (
      <AnimatePresence>
        <StaggeredList once={false}>
          {mergedData?.map(item => {
            return (
              <SpNftModalRowItem
                isMobile={isMobile}
                key={item.data.tokenId}
                poolAddress={item.poolAddress}
                tokenId={item.data.tokenId}
                tokenDetails={item.lpToken as PairToken}
              />
            );
          })}
        </StaggeredList>
      </AnimatePresence>
    );
  }

  const renderHeader = () => {
    if (!isMobile) {
      return <MySpNftHeader />;
    }

    return null;
  };

  return (
    <Box
      p={[0, '0 24px 24px']}
      borderRadius="16px"
      bg={['transparent', 'gray.3']}
      border={['none', '1px solid #232323']}
    >
      <Box className={s.container}>
        {renderHeader()}
        {renderList()}
      </Box>
    </Box>
  );
};
